module.exports = __webpack_public_path__ + "img/monitoring-car-blue.d7aa5835.svg";